import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseStoreService, BaseEntity } from './base-store.service';
import {apiUrl} from '../defines';
import {IdNameModel} from '../models/id.name.model';


@Injectable({
  providedIn: 'root'
})
export class FuelTypeStore extends BaseStoreService<BaseEntity> {
  baseUrl = `${apiUrl}`;
  protected http = inject(HttpClient);
  protected apiUrl = `${this.baseUrl}/references/fuelTypes`;

  protected getEntityName(): string {
    return 'Type de carburant';
  }

}
